import React, { FC } from "react";
import Input from "./input";
import { DateTime } from "luxon";

import "./input.css";

interface DateTimeInputProps {
  label?: string;
  subtitle?: string;
  error?: string;
  onChange?: (e) => void;
  onBlur?: () => void;
  disabled?: boolean;
  placeholder?: string;
  value?: string;
  width?: number;
  type?: string;
}

const DateTimeInput: FC<DateTimeInputProps> = ({
  label,
  subtitle,
  error,
  onChange = (e) => {},
  onBlur = () => {},
  disabled = false,
  placeholder,
  value,
  width,
}) => {
  let classes;

  if (error) {
    classes = "border-primary-red";
  } else {
    classes = "border-white opacity-64";
  }

  const now = DateTime.now().toFormat("yyyy-MM-dd'T'HH:mm");
  return (
    <div className="flex flex-col space-y-8">
      <Input label={label} subtitle={subtitle} error={error} width={width}>
        <input
          type="datetime-local"
          min={now}
          className={`${classes} bg-transparent py-12 pl-24 pr-24 body2 rounded-xxl h-44 border-2 placeholder-white placeholder-opacity-64 text-white focus:ring-none focus:border-current focus:outline-none fill-current focus:opacity-100 w-full`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
      </Input>
    </div>
  );
};

export default DateTimeInput;
